import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import Loading from '../loading-app/Loading';

export const RequiredAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const location = useLocation();

  useEffect(() => {
    if (!authState) return;
  
    if (!authState.isAuthenticated) {
      const next = location.pathname + location.search + location.hash;
      oktaAuth.setOriginalUri(next);
      oktaAuth.signInWithRedirect();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState?.isAuthenticated]);

  if (!authState) return <Loading />;
  if (!authState.isAuthenticated) return null;

  return <Outlet />;
};
